/* eslint-disable class-methods-use-this */
import urlUtil from './url';

class StatParamsPass {
    constructor({ vm, isSPA, isPublicFile }) {
        this.vm = vm;
        this.isSPA = isSPA || false;
        this.isPublicFile = isPublicFile || false;
        this.setAndUpdateLogSign = this.setAndUpdateLogSign.bind(this);
    }

    /**
     * 从链接上取透传参数存入localStorage
     * @returns
     */
    static getParamsFromUrl() {
        try {
            const statParamsPass = new StatParamsPass({});
            const query = urlUtil.getQuery(window.location.href);
            const hashQuery = urlUtil.getQuery(window.location.href, { fromHash: true });
            const logSign = query.logSign || hashQuery.logSign;
            const paramsStr = query.tcTJParams || hashQuery.tcTJParams;
            if (!paramsStr) return;
            const newParams = JSON.parse(paramsStr);
            statParamsPass.setAndUpdateLogSign(newParams, logSign);
        } catch (error) {
            console.error(error);
        }
    }

    /**
     * 移除透传所有参数
     */
    static removeParamsPass() {
        window.localStorage.removeItem('paramsPass');
    }

    setLogSign(params, logSign) {
        try {
            const curTime = `${new Date().getTime()}`;
            const newLogSign = logSign || curTime.substring(5, 13);
            const paramsObj = {
                time: curTime,
                logSign: newLogSign,
                params,
            };
            window.localStorage.setItem('paramsPass', JSON.stringify(paramsObj));
            return newLogSign;
        } catch (error) {
            console.error(error);
            return '';
        }
    }

    updateLogSign(newParams) {
        try {
            const paramsStr = window.localStorage.getItem('paramsPass');
            if (!paramsStr) {
                console.log('StatParamsPass updataLogSign 调用错误：请先调用setLogSign');
                return;
            }
            const paramsObj = JSON.parse(paramsStr);
            paramsObj.params = Object.assign(paramsObj.params, newParams);
            window.localStorage.setItem('paramsPass', JSON.stringify(paramsObj));
        } catch (error) {
            console.error(error);
        }
    }

    // 判断链接中是否有参数logSign,若有，则updata返回logSign，没有则set并返回logSign
    setAndUpdateLogSign(newParams, logSign = this.getQuery()) {
        try {
            const params = this.getLogSign(logSign);
            if (!logSign || !params || !Object.keys(params).length) {
                console.log('更新失败，重置logSign');
                return this.setLogSign(newParams, logSign);
            }
            this.updateLogSign(newParams);

            return logSign;
        } catch (error) {
            console.error(error);
            return '';
        }
    }

    deleteLogSign(paramsNameArr = []) {
        try {
            const paramsStr = window.localStorage.getItem('paramsPass');
            if (!paramsStr) {
                console.log('StatParamsPass deleteLogSign 调用错误：请先调用setLogSign');
                return;
            }
            const paramsObj = JSON.parse(paramsStr);
            paramsNameArr.forEach(item => {
                delete paramsObj.params[item];
            });
            window.localStorage.setItem('paramsPass', JSON.stringify(paramsObj));
        } catch (error) {
            console.error(error);
        }
    }

    /**
     * 获取传递参数
     *
     *
     */
    getLogSign(logSign = this.getQuery()) {
        let paramsObj;
        const paramsStr = window.localStorage.getItem('paramsPass');
        if (!paramsStr) {
            return {};
        }
        try {
            paramsObj = JSON.parse(paramsStr);
        } catch (error) {
            console.log(error);
            return {};
        }

        // 判断是否一致logSign
        if (paramsObj.logSign === logSign) {
            return paramsObj.params;
        }
        return {};
    }

    getQuery() {
        // let UA = window.ZZCFL.Utils.UA;
        // let isApp = UA.browser.name === 'black';
        let result;

        if (this.isPublicFile && this.isSPA) {
            const urlHashParmas = urlUtil.getQuery(window.location.href, { fromHash: true });
            result = urlHashParmas.logSign;
            // 如果hash没有，再检测hash前的url有没有query参数
            if (!result) {
                const urlparams = urlUtil.getQuery(window.location.href);
                result = urlparams.logSign;
            }
        } else if (this.isSPA) {
            result = this.vm.$route.query.logSign;
        } else {
            const { search } = window.location;
            const queryObj = {};
            if (search.indexOf('?') !== -1) {
                let params = search.substr(1);
                params = params.split('&');
                // eslint-disable-next-line no-plusplus
                for (let i = 0; i < params.length; i++) {
                    const query = params[i].split('=');
                    // eslint-disable-next-line prefer-destructuring
                    queryObj[query[0]] = query[1];
                }
            }
            result = queryObj.logSign;
        }

        return result;
    }
}
export default StatParamsPass;
